import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import 'rxjs/add/operator/debounceTime';
import { Contact } from '../model/contact';
import { ContactService } from '../service/contact.service';
import { TraceService } from '../service/trace.service';
import { Meta } from '@angular/platform-browser';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup
  contact: Contact;
  firstNameErrorMessage: string = this.i18n({
    id: 'lastName',
    value: "Le nom doit être compris entre 3 et 30 caractères",
    description: "Le nom doit être compris entre 3 et 30 caractères",
    meaning: "contact"
  }) 
  lastNameErrorMessage: string = this.i18n({
    id: 'firstName',
    value: "Le prénom doit être compris entre 3 et 30 caractères",
    description: "Le prénom doit être compris entre 3 et 30 caractères",
    meaning: "contact"
  })
  emailErrorMessage: string = this.i18n({
    id: 'email',
    value: "Veuillez introduire une adresse email valide",
    description: "Veuillez introduire une adresse email valide",
    meaning: "contact"
  })
  entrepriseErrorMessage: string = this.i18n({
    id: 'companyName',
    value: "Le nom de l'entreprise doit être compris entre 2 et 30 caractères",
    description: "Le nom de l'entreprise doit être compris entre 2 et 30 caractères",
    meaning: "contact"
  })
  messageErrorMessage: string = this.i18n({
    id: 'message',
    value: "Veuillez écrire un message entre 28 et 1000 caractères",
    description: "Veuillez écrire un message entre 28 et 1000 caractères",
    meaning: "contact"
  })
  hideForm: boolean = true;
  sended: boolean = false;

  constructor(private _fb: FormBuilder, private _location: Location, private _router: Router,
              private readonly i18n: I18n,
              private _contactService: ContactService, private _traceService: TraceService) {
    this.contactForm = _fb.group({
      'firstName': [null, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])],
      'lastName': [null, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])],
      'email': [null, Validators.compose([Validators.required, Validators.email])],
      'entreprise': [null, Validators.compose([Validators.required, Validators.maxLength(30)])],
      'subject': ['Anomalies (bug)', Validators.compose([Validators.required])],
      'message': [null, Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(1000)])],
    });

    this.contactForm.valueChanges.debounceTime(500)
      .subscribe(data => {
        this.contact = this.prepareSaveContact();
      });
  }

  ngOnInit() { }

  send(form: Contact): void {
    // this._contactService.sendMail(this.contactForm.controls['subject'].value,
    // this.contactForm.controls['message'].value,
    // this.contactForm.controls['firstName'].value).subscribe(
    //   data => {
    //     this.hideForm = false;
    //     console.log("data ",data);
    //   },
    //   error => {
    //     console.error(error);
    //   }
    // );

     this._contactService.sendMail(this.contactForm.controls['subject'].value,
                                   this.contactForm.controls['message'].value,
                                   this.contactForm.controls['firstName'].value,
                                   this.contactForm.controls['entreprise'].value).then(result => {

                                     this.hideForm = false;
    });
    this._traceService.saveTrace(null, "send mail button via assistance");
  }

  prepareSaveContact(): Contact {
    const saveContact: Contact = {
      id: null,
      firstName: this.contactForm.controls['firstName'].value as string,
      lastName: this.contactForm.controls['lastName'].value as string,
      email: this.contactForm.controls['email'].value as string,
      entreprise: this.contactForm.controls['entreprise'].value as string,
      subject: this.contactForm.controls['subject'].value as string,
      message: this.contactForm.controls['message'].value as string,
    };
    return saveContact;
  }

}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts